export enum EOaCreationJobStatus {
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  PAUSED = 'PAUSED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  ROLLED_BACK = 'ROLLED_BACK',
  ROLLBACK_TODO = 'ROLLBACK_TODO',
  CANCELLED = 'CANCELLED',
}

export enum EOaCreationAccountStatus {
  PENDING = 'PENDING',
  CREATING = 'CREATING',
  CREATED = 'CREATED',
  FAILED = 'FAILED',
  ROLLED_BACK = 'ROLLED_BACK',
}

export type TOaCreationAccount = {
  id: number
  sequenceNo: number
  status: EOaCreationAccountStatus
  basicId: string | null
  failureReason: string | null
  attemptCount: number
  startedAt: string | null
  finishedAt: string | null
  createdAt: string
  updatedAt: string
}

export type TOaCreationJob = {
  id: number
  businessAccount: string
  accountName: string
  quantity: number
  iconImageUrl: string | null
  email: string
  status: EOaCreationJobStatus
  successCount: number
  failedCount: number
  errorMessage: string | null
  /** PAUSED 時の中断理由（CAPTCHA タイムアウト・ユーザー手動 Stop など） */
  pauseReason: string | null
  startedAt: string | null
  finishedAt: string | null
  createdAt: string
  updatedAt: string
  createdById: number
  organizationId: number
  accounts: TOaCreationAccount[]
}

export type TOaCreationJobListItem = Omit<
  TOaCreationJob,
  'accounts' | 'errorMessage' | 'updatedAt'
>

export type TListOaCreationJobsResponse = {
  data: TOaCreationJobListItem[]
  total: number
  currentPage: number
  totalPage: number
}

export type TCreateOaCreationJobRequest = {
  businessAccount: string
  accountName: string
  quantity: number
  iconImageUrl?: string
  email: string
}
